define.alias("shared/components/shared/publish/switcher/index", "preview-grid/components/shared/publish/switcher/index");